import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'defaultMoney' })
export class DefaultMoneyPipe implements PipeTransform {
  transform(value: number | null): string {
    return value ? `${value.toLocaleString()} ¥` : 'N/A';
  }
}
